import React from 'react';

import { LazyTeamCalendars, CALENDAR_CONTEXT } from '@confluence/team-calendar';

export function MultipleCalendarRoute() {
	return <LazyTeamCalendars calendarContext={CALENDAR_CONTEXT.MULTIPLE_CALENDARS} />;
}

MultipleCalendarRoute.NAVIGATION_PARAMS = ({ spaceKey }) => ({
	Screen: {
		screenEvent: {
			name: 'multipleCalendarsScreen',
			id: spaceKey,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		spaceKey,
	},
});
